module.exports = __webpack_public_path__ + "static/img/naniungo-3.40fd7a87.jpg";